import { parseTemplate } from 'url-template';
import { Export } from '~/Api/User/ProductGroup/Export';
import ApiClient, { ApiClientErrorResponse } from '~/ApiClient';

import { ErrorResponse } from './ErrorResponse';

export enum ExportType {
	annex1Xls = 'annex1-xls',
	annex1Pdf = 'annex1-pdf',
	machetaXls = 'macheta-xls',
	recipeData = 'input-recipe-data-xls',
}

export interface Result {
	readonly export: Export;
}

export const createExport = async (
	client: ApiClient,
	userId: string,
	groupId: string,
	type: ExportType
): Promise<Result> => {
	const url = parseTemplate('users/{userId}/product-groups/{groupId}/ro-max-price/export-{type}');
	return client
		.fetch(url.expand({ userId, groupId, type }), { method: 'POST' })
		.then((response) => response.json())
		.catch((response) => ApiClientErrorResponse.wrapError(response, ErrorResponse));
};
